/**
 * `property_management.leases` (M42): the Property management lease knobs. One so far:
 *
 *   expiring_alert_months   a managed lease whose expiration falls within this many
 *                           months from today counts as "expiring soon": the in-app
 *                           indicator on the Property management tabs and the
 *                           banner of Lease expirations (API data/property-management-
 *                           lease-expirations-reads.ts reads it in its statement, settingSql)
 *
 * Who: editPermission feature:property_management_work (the Property management
 * workers; admins always pass). No readPermission: the endpoints that use it
 * answer the value with their data. Edited on Settings → App settings. Default 6 (M42).
 */
import { z } from 'zod';
import { defineGroup } from '../define.js';
export const propertyManagementLeases = defineGroup('property_management.leases', {
    label: 'Property management lease alerts',
    editPermission: 'feature:property_management_work',
    settings: {
        expiring_alert_months: {
            type: z.number().int().min(1).max(36),
            default: 6,
            label: 'Expiring soon (months)',
            help: 'A managed lease that expires within this many months from today is flagged as expiring soon in Property management.',
        },
    },
});
//# sourceMappingURL=property-management.js.map